import React from 'react';

const HappyFaceIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width="158"
      height="93"
      viewBox="0 0 158 93"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props} // allows passing custom props like className, style, etc.
    >
      <g clipPath="url(#clip0_602_3480)">
        <path
          d="M79.05 93.0012C49.4779 93.0012 22.3438 78.5079 8.24616 55.1901C7.4287 53.8335 7.87329 52.0772 9.22138 51.2633C10.5838 50.4494 12.3478 50.892 13.1653 52.2343C26.2304 73.8529 51.4714 87.2753 79.05 87.2753C106.629 87.2753 131.87 73.8529 144.935 52.2343C145.752 50.8778 147.516 50.4494 148.864 51.2633C150.227 52.0772 150.657 53.8335 149.84 55.1758C135.742 78.4936 108.608 92.9869 79.0357 92.9869L79.05 93.0012Z"
          fill="#F6B704"
        />
        <path
          d="M2.86823 63.6454C2.63877 63.6454 2.4093 63.6168 2.17984 63.5597C0.645303 63.1741 -0.286893 61.6463 0.0859857 60.1184C1.37672 54.8208 7.52921 45.4109 21.5695 47.7384C23.1327 47.9954 24.194 49.4662 23.9215 51.0226C23.6634 52.579 22.1862 53.6357 20.623 53.3644C8.61916 51.3796 5.92297 60.4325 5.65048 61.4749C5.32062 62.76 4.14462 63.6311 2.86823 63.6311V63.6454Z"
          fill="#F6B704"
        />
        <path
          d="M155.131 63.661C153.841 63.661 152.679 62.79 152.349 61.4906C152.077 60.4339 149.381 51.4095 137.377 53.38C135.813 53.637 134.336 52.5947 134.078 51.0382C133.82 49.4818 134.867 48.011 136.43 47.754C150.485 45.4265 156.623 54.8365 157.914 60.134C158.287 61.6619 157.34 63.2041 155.805 63.5753C155.576 63.6324 155.347 63.661 155.131 63.661Z"
          fill="#F6B704"
        />
        <path
          d="M52.6615 9.28144C52.6615 14.4076 48.4881 18.5629 43.3395 18.5629C38.1909 18.5629 34.0176 14.4076 34.0176 9.28144C34.0176 4.15523 38.2053 0 43.3539 0C48.5025 0 52.6758 4.15523 52.6758 9.28144H52.6615Z"
          fill="#F6B704"
        />
        <path
          d="M124.541 9.28144C124.541 14.4076 120.368 18.5629 115.219 18.5629C110.071 18.5629 105.897 14.4076 105.897 9.28144C105.897 4.15523 110.071 0 115.219 0C120.368 0 124.541 4.15523 124.541 9.28144Z"
          fill="#F6B704"
        />
      </g>
      <defs>
        <clipPath id="clip0_602_3480">
          <rect width="158" height="93" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default HappyFaceIcon;
